import axios from 'axios';
import {createAction} from 'redux-actions';

export default createAction('GET_PAGE', async id => {
	const {data: [body]} = await axios(`${API}/wp/v2/pages?slug=${id}`);

	if (!body) {
		return false;
	}

	if (body && body.featured_media) {
		body.featured_media = (await axios(`${API}/wp/v2/media/${body.featured_media}`)).data;
	}

	return body;
});



// WEBPACK FOOTER //
// actions/pages.js